import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Transition as _Transition, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "error-msg" }
const _hoisted_2 = { class: "w-100 space-y-2" }
const _hoisted_3 = { class: "col-span-2" }
const _hoisted_4 = { class: "col-span-4" }
const _hoisted_5 = { class: "col-span-2" }
const _hoisted_6 = {
  key: 0,
  class: "col-span-1 flex flex-row"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "flex-grow" }, null, -1)
const _hoisted_8 = { class: "px-1 py-1" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 1,
  class: "col-span-5 col-start-2"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row justify-center w-full" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "w-full h-px bg-gray-300" })
], -1)
const _hoisted_12 = [
  _hoisted_11
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DotsVerticalIcon = _resolveComponent("DotsVerticalIcon")!
  const _component_MenuButton = _resolveComponent("MenuButton")!
  const _component_UserRemoveIcon = _resolveComponent("UserRemoveIcon")!
  const _component_MenuItem = _resolveComponent("MenuItem")!
  const _component_MenuItems = _resolveComponent("MenuItems")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_UserDeletionModal = _resolveComponent("UserDeletionModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.error), 1),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (cu, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "flex flex-col md:grid md:grid-cols-9",
          key: cu.user.id
        }, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(cu.user.fullName), 1),
          _createElementVNode("div", _hoisted_4, _toDisplayString(cu.user.email), 1),
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.companyUserTypeString(cu.userType)), 1),
          (_ctx.isAdmin && cu.userType != 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _hoisted_7,
                _createVNode(_component_Menu, {
                  as: "div",
                  class: "relative inline-block text-left"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createVNode(_component_MenuButton, { class: "inline-flex justify-center w-full p-2 text-sm font-medium text-black bg-teal rounded-md bg-opacity-0 hover:bg-opacity-30" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_DotsVerticalIcon, {
                            class: "w-5 h-5 text-black",
                            "aria-hidden": "true"
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _createVNode(_Transition, {
                      "enter-active-class": "transition duration-100 ease-out",
                      "enter-from-class": "transform scale-95 opacity-0",
                      "enter-to-class": "transform scale-100 opacity-100",
                      "leave-active-class": "transition duration-75 ease-in",
                      "leave-from-class": "transform scale-100 opacity-100",
                      "leave-to-class": "transform scale-95 opacity-0"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_MenuItems, { class: "absolute right-0 w-56 mt-2 origin-top-right bg-white divide-y divide-gray-100 rounded-md shadow-lg focus:outline-none z-10" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_8, [
                              _createVNode(_component_MenuItem, {
                                as: "div",
                                class: "w-full"
                              }, {
                                default: _withCtx(({ active }) => [
                                  _createElementVNode("button", {
                                    class: _normalizeClass([
                                            active ? 'bg-red-600 text-white' : 'text-red-600',
                                            'group flex rounded-md items-center w-full px-2 py-2 text-sm',
                                        ]),
                                    onClick: ($event: any) => (_ctx.showDelete(cu))
                                  }, [
                                    _createVNode(_component_UserRemoveIcon, {
                                      active: active,
                                      class: _normalizeClass([[active ? 'text-white' : 'text-red-600'], "w-5 h-5 mr-2"]),
                                      "aria-hidden": "true"
                                    }, null, 8, ["active", "class"]),
                                    _createTextVNode(" Remove User ")
                                  ], 10, _hoisted_9)
                                ]),
                                _: 2
                              }, 1024)
                            ])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)
              ]))
            : _createCommentVNode("", true),
          (index < _ctx.users.length - 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ]),
    (_ctx.userToDelete)
      ? (_openBlock(), _createBlock(_component_UserDeletionModal, {
          key: 0,
          user: _ctx.userToDelete,
          onCompleted: _ctx.userDeleted
        }, null, 8, ["user", "onCompleted"]))
      : _createCommentVNode("", true)
  ], 64))
}